import React from 'react';

/* eslint-disable */

const BestOdds = () => (
    <div className="js-PC-runnerBestOddsContainer">
        <div className="PC-bestOddsContainer js-bestOddsContainer">
            <div className="PC-bestOdds__shadow js-PC-bestOdds__shadow" />
            <div className="PC-bestOdds js-PC-bestOdds">
                <div className="PC-bestOdds__arrow js-PC-bestOdds__arrow" />
                <div className="PC-bestOdds__horseName js-bestOddsHorseName" />
                <div className="PC-bestOdds__headers">
                    <div
                        className="PC-bestOdds__headers__field
                        PC-bestOdds__headers__field_bookmaker"
                    >
                        Bookmaker
                    </div>
                    <div
                        className="PC-bestOdds__headers__field
                        PC-bestOdds__headers__field_price"
                    >
                        Price
                    </div>
                    <div
                        className="PC-bestOdds__headers__field
                        PC-bestOdds__headers__field_terms"
                    >
                        E.W. Terms
                    </div>
                </div>
                <div className="PC-bestOdds__bookiesList PC-bestOdds__bookiesList_betslip">
                    <div
                        className="PC-bestOdds__bookieRow
                        PC-bestOdds__bookieRow_betslip
                        js-diffusionBestOdds"
                        data-diffusion-horsename=""
                        data-diffusion-bookmaker="BET365"
                        data-diffusion-bookieName="bet365"
                    >
                        <div className="PC-bestOdds__bookieRow__name">
                            <div>
                                bet365
                            </div>
                            <a
                                href="https://members.bet365.com/Members/OpenAccount/?affiliate=365_386841&prdid=1&ibpid=2200&lng=1&rUrl=www%2Eracingpost%2Ecom&oty=1&ver=2" // eslint-disable-line max-len
                                target="_blank"
                                rel="noopener noreferrer"
                                className="PC-bestOdds__bookieRow__name_account"
                            >
                                Open Account
                            </a>
                        </div>
                        <div className="PC-bestOdds__bookieRow__price">
                            <div
                                className="ui-btn PC-bestOdds__bookieRow__priceBtn
                                ui-priceBtn_bet365 js-betHandler
                                js-PC-bestOdds__priceBtn"
                            />
                        </div>
                        <div
                            className="PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
                        />
                        <div
                            className="PC-bestOdds__bookieRow__oddsIcon
                            PC-bestOdds__bookieRow__oddsIcon_betslip
                            js-diffusionBestOdds_bog"
                        />
                    </div>
                    <div
                        className="PC-bestOdds__bookieRow
                        PC-bestOdds__bookieRow_betslip
                        js-diffusionBestOdds"
                        data-diffusion-horsename=""
                        data-diffusion-bookmaker="LADB"
                        data-diffusion-bookieName="ladbrokes"
                    >
                        <div className="PC-bestOdds__bookieRow__name">
                            <div>Ladbrokes</div>
                            <a
                                href="http://online.ladbrokes.com/promoRedirect?key=ej0xMzc3MTI2OSZsPS0xJnA9NjgwNDk4"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="PC-bestOdds__bookieRow__name_account"
                            >
                                Open Account
                            </a>
                        </div>
                        <div className="PC-bestOdds__bookieRow__price">
                            <div
                                className="ui-btn PC-bestOdds__bookieRow__priceBtn
                                ui-priceBtn_ladbrokes js-betHandler
                                js-PC-bestOdds__priceBtn"
                            />
                        </div>
                        <div
                            className="PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
                        />
                        <div
                            className="PC-bestOdds__bookieRow__oddsIcon
                            PC-bestOdds__bookieRow__oddsIcon_betslip
                            js-diffusionBestOdds_bog"
                        />
                    </div>
                    <div
                        className="PC-bestOdds__bookieRow js-diffusionBestOdds"
                        data-diffusion-horsename=""
                        data-diffusion-bookmaker="PPWR"
                        data-diffusion-bookieName="paddypower"
                    >
                        <div className="PC-bestOdds__bookieRow__name">
                            Paddy Power
                        </div>
                        <div className="PC-bestOdds__bookieRow__price">
                            <div
                                className="ui-btn PC-bestOdds__bookieRow__priceBtn
                                ui-priceBtn_paddypower js-betHandler
                                js-PC-bestOdds__priceBtn"
                            />
                        </div>
                        <div
                            className="PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
                        />
                        <div
                            className="PC-bestOdds__bookieRow__oddsIcon js-diffusionBestOdds_bog"
                        />
                    </div>
                    <div
                        className="PC-bestOdds__bookieRow js-diffusionBestOdds"
                        data-diffusion-horsename=""
                        data-diffusion-bookmaker="BETFAIR"
                        data-diffusion-bookieName="betfair"
                    >
                        <div className="PC-bestOdds__bookieRow__name">
                            Betfair
                        </div>
                        <div className="PC-bestOdds__bookieRow__price">
                            <div
                                className="ui-btn PC-bestOdds__bookieRow__priceBtn
                                ui-priceBtn_betfair js-betHandler
                                js-PC-bestOdds__priceBtn"
                            />
                        </div>
                        <div
                            className="PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
                        />
                        <div
                            className="PC-bestOdds__bookieRow__oddsIcon js-diffusionBestOdds_bog"
                        />
                    </div>
                    <div
                        className="PC-bestOdds__bookieRow
                        PC-bestOdds__bookieRow_betslip
                        js-diffusionBestOdds"
                        data-diffusion-horsename=""
                        data-diffusion-bookmaker="WH_OXI"
                        data-diffusion-bookieName="williamHill"
                    >
                        <div className="PC-bestOdds__bookieRow__name">
                            <div>
                                William Hill
                            </div>
                            <a
                                href="http://ads2.williamhill.com/redirect.aspx?pid=185759757&lpid=1487411833&bid=1487411716" // eslint-disable-line max-len
                                target="_blank"
                                rel="noopener noreferrer"
                                className="PC-bestOdds__bookieRow__name_account"
                            >
                                Open Account
                            </a>
                        </div>
                        <div className="PC-bestOdds__bookieRow__price">
                            <div
                                className="ui-btn PC-bestOdds__bookieRow__priceBtn
                                ui-priceBtn_williamHill js-betHandler
                                js-PC-bestOdds__priceBtn"
                            />
                        </div>
                        <div
                            className="PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
                        />
                        <div
                            className="PC-bestOdds__bookieRow__oddsIcon
                            PC-bestOdds__bookieRow__oddsIcon_betslip
                            js-diffusionBestOdds_bog"
                        />
                    </div>
                    <div
                        className="PC-bestOdds__bookieRow
                        PC-bestOdds__bookieRow_betslip
                        js-diffusionBestOdds"
                        data-diffusion-horsename=""
                        data-diffusion-bookmaker="CORAL"
                        data-diffusion-bookieName="coral"
                    >
                        <div className="PC-bestOdds__bookieRow__name">
                            <div>
                                Coral
                            </div>
                            <a
                                href="http://affiliate.coral.co.uk/processing/clickthrgh.asp?btag=a_2757b_6528" // eslint-disable-line max-len
                                target="_blank"
                                rel="noopener noreferrer"
                                className="PC-bestOdds__bookieRow__name_account"
                            >
                                Open Account
                            </a>
                        </div>
                        <div className="PC-bestOdds__bookieRow__price">
                            <div
                                className="ui-btn PC-bestOdds__bookieRow__priceBtn
                                ui-priceBtn_coral js-betHandler
                                js-PC-bestOdds__priceBtn"
                            />
                        </div>
                        <div
                            className="PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
                        />
                        <div
                            className="PC-bestOdds__bookieRow__oddsIcon
                            PC-bestOdds__bookieRow__oddsIcon_betslip
                            js-diffusionBestOdds_bog"
                        />
                    </div>
                    <div
                        className="PC-bestOdds__bookieRow
                        PC-bestOdds__bookieRow_betslip
                        js-diffusionBestOdds"
                        data-diffusion-horsename=""
                        data-diffusion-bookmaker="SURREY"
                        data-diffusion-bookieName="skybet"
                    >
                        <div className="PC-bestOdds__bookieRow__name">
                            <div>Sky Bet</div>
                            <a
                                href="https://m.skybet.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                                className="PC-bestOdds__bookieRow__name_account"
                            >
                                Open Account
                            </a>
                        </div>
                        <div className="PC-bestOdds__bookieRow__price">
                            <div
                                className="ui-btn PC-bestOdds__bookieRow__priceBtn
                                ui-priceBtn_skybet js-betHandler
                                js-PC-bestOdds__priceBtn"
                            />
                        </div>
                        <div
                            className="PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
                        />
                        <div
                            className="PC-bestOdds__bookieRow__oddsIcon
                            PC-bestOdds__bookieRow__oddsIcon_betslip
                            js-diffusionBestOdds_bog"
                        />
                    </div>
                </div>

                <div className="PC-bestOdds__bookiesList">
                    <div
                        className="PC-bestOdds__bookieRow js-diffusionBestOdds"
                        data-diffusion-horsename=""
                        data-diffusion-bookmaker="SPORTING INDEX"
                        data-diffusion-bookieName="sportingBet"
                    >
                        <div className="PC-bestOdds__bookieRow__name">
                            Sporting
                        </div>
                        <div className="PC-bestOdds__bookieRow__price">
                            <div
                                className="ui-btn PC-bestOdds__bookieRow__priceBtn
                                ui-priceBtn_sportingBet js-betHandler
                                js-PC-bestOdds__priceBtn"
                            />
                        </div>
                        <div
                            className="PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
                        />
                        <div
                            className="PC-bestOdds__bookieRow__oddsIcon js-diffusionBestOdds_bog"
                        />
                    </div>
                    <div
                        className="PC-bestOdds__bookieRow js-diffusionBestOdds"
                        data-diffusion-horsename=""
                        data-diffusion-bookmaker="VC"
                        data-diffusion-bookieName="betVictor"
                    >
                        <div className="PC-bestOdds__bookieRow__name">
                            BetVictor
                        </div>
                        <div className="PC-bestOdds__bookieRow__price">
                            <div
                                className="ui-btn PC-bestOdds__bookieRow__priceBtn
                                ui-priceBtn_betVictor js-betHandler
                                js-PC-bestOdds__priceBtn"
                            />
                        </div>
                        <div
                            className="PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
                        />
                        <div
                            className="PC-bestOdds__bookieRow__oddsIcon js-diffusionBestOdds_bog"
                        />
                    </div>
                    <div
                        className="PC-bestOdds__bookieRow js-diffusionBestOdds"
                        data-diffusion-horsename=""
                        data-diffusion-bookmaker="BOLEYSPORTS"
                        data-diffusion-bookieName="boylesport"
                    >
                        <div className="PC-bestOdds__bookieRow__name">
                            Boylesport
                        </div>
                        <div className="PC-bestOdds__bookieRow__price">
                            <div
                                className="ui-btn PC-bestOdds__bookieRow__priceBtn
                                ui-priceBtn_boylesport js-betHandler
                                js-PC-bestOdds__priceBtn"
                            />
                        </div>
                        <div
                            className="PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
                        />
                        <div
                            className="PC-bestOdds__bookieRow__oddsIcon js-diffusionBestOdds_bog"
                        />
                    </div>
                    <div
                        className="PC-bestOdds__bookieRow js-diffusionBestOdds"
                        data-diffusion-horsename=""
                        data-diffusion-bookmaker="888"
                        data-diffusion-bookieName="888sport"
                    >
                        <div className="PC-bestOdds__bookieRow__name">
                            888sport
                        </div>
                        <div className="PC-bestOdds__bookieRow__price">
                            <div
                                className="ui-btn PC-bestOdds__bookieRow__priceBtn
                                ui-priceBtn_888sport js-betHandler
                                js-PC-bestOdds__priceBtn"
                            />
                        </div>
                        <div
                            className="PC-bestOdds__bookieRow__terms js-diffusionBestOdds_eachWay"
                        />
                        <div
                            className="PC-bestOdds__bookieRow__oddsIcon js-diffusionBestOdds_bog"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
);

/* eslint-enable */

export default BestOdds;



// WEBPACK FOOTER //
// ./src/js/shared/price/BestOdds.jsx